var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutdatedLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 42,
    cy: 42,
    rx: 36,
    ry: 36,
    transform: "rotate(180 42 42)",
    fill: "#F3566A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 40C4.5 20.3939 20.3939 4.5 40 4.5C59.6061 4.49999 75.5 20.3939 75.5 40C75.5 59.6061 59.6061 75.5 40 75.5C20.3939 75.5 4.50001 59.6061 4.5 40Z",
    stroke: "#1F232B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52L53 28M53 52L29 28",
    stroke: "#1F232B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdatedLinkIcon);
export default __webpack_public_path__ + "static/media/outdated-link-icon.dda8cbf4e9cce46a866467b09667b683.svg";
export { ForwardRef as ReactComponent };